import { KeyboardEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { CreatableSelect, InputActionMeta, MultiValue, OnChangeValue } from '@any-ui-react/select';

import { BasicOption } from '@anyx/shared-utils';

import { MultiValueRemove } from './MultiValueRemove';

type CustomerTagOption = BasicOption<string>;

interface CreateCustomerTagInputProps {
  onChange: (values: OnChangeValue<CustomerTagOption, true>) => void;
  onInputChange: (newInputValue: string, actionMeta: InputActionMeta) => void;
  placeholder?: string;
  inputValue?: string;
  onKeyDown: KeyboardEventHandler<HTMLDivElement>;
  value?: MultiValue<CustomerTagOption>;
}

export const CreateCustomerTagInput = ({ placeholder, ...props }: CreateCustomerTagInputProps) => {
  const { t } = useTranslation('anychat');

  return (
    <CreatableSelect
      {...props}
      className="anc-tag-select"
      classNames={{
        valueContainer: () => 'max-h-40 overflow-y-auto!',
      }}
      components={{
        DropdownIndicator: null,
        MultiValueRemove,
      }}
      placeholder={placeholder ? placeholder : t('anychat.customer.customerTagPopover.placeholder')}
      isClearable={false}
      isMulti
      menuIsOpen={false}
      autoFocus
      backspaceRemovesValue={false}
    />
  );
};
